// Shared Tailwind class constants for the super-admin dashboard "upcoming"
// tables (formerly the .dashboard-table-body and .upcoming-table CSS rules).

// Scrollable body wrapper with a custom slim scrollbar.
export const dashboardTableBodyClasses =
    'max-h-125 overflow-y-auto w-full min-h-0 ' +
    '[&::-webkit-scrollbar]:w-1.5 ' +
    '[&::-webkit-scrollbar-thumb]:bg-disabled [&::-webkit-scrollbar-thumb]:rounded';

// Stone header row, matching the settlement table; the mint it replaced was a
// blue-brand tint rather than a table surface.
export const tableHeaderRowClasses = 'bg-table-header border-b border-border';

// Fixed-layout table whose body rows truncate long values cleanly.
export const upcomingTableClasses =
    'w-full border-collapse table-fixed ' +
    '[&_tbody_td]:overflow-hidden [&_tbody_td]:text-ellipsis [&_tbody_td]:h-12 ' +
    '[&_tbody_td]:px-2 [&_tbody_td]:py-4 [&_tbody_td]:whitespace-nowrap ' +
    '[&_tbody_td]:text-content [&_tbody_td]:text-sm [&_tbody_td]:leading-[21px] ' +
    "[&_tbody_td]:font-['Open_Sans',sans-serif] " +
    '[&_tbody_td]:bg-white [&_tbody_td]:border-b [&_tbody_td]:border-border';
